const MixpanelEventType = () => {
  const MIXPANEL_EVENTS = {
    ORGANIC_SIGNUP_EVENT: {
      type: "Signed Up",
      label: {
        label: "sign-up",
        "Signup Type": "Organic"
      }
    },
    REFERRAL_SIGNUP_EVENT: {
      type: "Signed Up",
      label: {
        label: "sign-up",
        "Signup Type": "Referral"
      }
    },
    SIGNUP_COMPLETE_DEMO_ACCOUNT: {
      type: "signupComplete",
      label: {
        label: "complete-demo-account"
      }
    },
    COMPLETE_DEMO_ACCOUNT: {
      type: "completeDemoAccount",
      label: {
        action: "registered",
        email: null
      }
    },
    LOGIN_EVENT: {
      type: "Logged In",
      label: {
        label: "log-in"
      }
    },
    LOGOUT_EVENT: {
      type: "Logged Out",
      label: {
        label: "log-out"
      }
    },
    CONFIRMATION_EVENT: {
      type: "User Confirmed",
      label: {
        label: "confirmation"
      }
    },
    PARTNER_SUBMIT: {
      type: "partnerSubmit",
      label: {
        beneficial_owner_id: null,
        ip_address: null
      }
    },
    APPROVE_INVOICE: {
      type: "invoiceFullyFunded",
      label: {
        label: "approve-invoice",
        "FT Customer ID": null,
        "FT Quote ID": null,
        current_status: null
      }
    },
    FUNDED_INVOICE: {
      type: "invoiceFullyFunded",
      label: {
        label: "fund-invoice",
        "FT Customer ID": null,
        "FT Quote ID": null
      }
    },
    REJECT_INVOICE: {
      type: "Rejected Invoice",
      label: {
        label: "reject-invoice",
        "FT Customer ID": null,
        "FT Quote ID": null
      }
    },
    CLIENT_STATUS_PRE_APPROVED: {
      type: "preApproved",
      label: {
        label: "preApproved",
        "Client Status": "PreApproved"
      }
    },
    CLIENT_STATUS_APPROVED: {
      type: "Approved",
      label: {
        label: "Approved",
        "Client Status": "Approved"
      }
    },
    SUBMIT_INVOICE: {
      type: "submitInvoice",
      label: {
        label: "submit-invoice",
        invoice_bucket: null,
        user_id: null,
        facility_limit: null
      }
    },
    UPDATE_USER_DETAILS: {
      type: "userUserDetails",
      label: {
        $phone: null,
        Referrer: null,
        "Promo Code": null,
        $first_name: null,
        $last_name: null,
        $email: null,
        Role: null,
        "Display Name": null,
        "Middle Name": null,
        "Date of Birth": null,
        "Phone (Secondary)": null,
        "Last Visit": null
      }
    },
    MYOB_CONNECT_ACCOUNTING_SOFTWARE: {
      type: "linkedAccounting",
      label: {
        label: "connect-book",
        "Accounting Software": "MYOB"
      }
    },
    MANUAL_INVOICE_UPLOAD: {
      type: "manualInvoiceUpload",
      label: {
        user_id: null,
        invoices_count: null,
        is_first_upload: null
      }
    },
    XERO_CONNECT_ACCOUNTING_SOFTWARE: {
      type: "linkedAccounting",
      label: {
        label: "connect-book",
        "Accounting Software": "Xero"
      }
    },
    QUICKBOOK_CONNECT_ACCOUNTING_SOFTWARE: {
      type: "linkedAccounting",
      label: {
        label: "connect-book",
        "Accounting Software": "QuickBooks"
      }
    },
    RECKON_CONNECT_ACCOUNTING_SOFTWARE: {
      type: "linkedAccounting",
      label: {
        label: "connect-book",
        "Accounting Software": "Reckon"
      }
    },
    COMPLETE_AML: {
      type: "Completed AML",
      label: {
        label: "complete-aml"
      }
    },
    APPLYID_COMPLETE: {
      type: "idComplete",
      label: {
        label: "onboarding_id_complete",
        "FT Customer ID": null
      }
    }
  };

  return { MIXPANEL_EVENTS };
};

export default MixpanelEventType;
